module.exports = __webpack_public_path__ + "a17d279f/img/pwrd-by-sourcery-black.bba9ba41.svg";